<template>
	<div v-if="item.lots || item.serials">
		<v-chip small :color="chipColor" :outlined="!covered" @click="open = true">
			<v-icon small left>{{ item.serials ? 'mdi-barcode' : 'mdi-package-variant-closed' }}</v-icon>
			{{ label }}
			<v-icon v-if="automatic" small right title="Assegnati in automatico dal documento d'origine">mdi-auto-fix</v-icon>
		</v-chip>
		<v-dialog v-model="open" max-width="560">
			<v-card>
				<v-card-title class="subtitle-1">{{ item.name }}</v-card-title>
				<v-card-text>
					<lot-allocations-editor
						v-if="open"
						:field="field"
						:model="model"
						@allocations-changed="onChanged"
					></lot-allocations-editor>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="open = false">Chiudi</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import Vue from 'vue'
import LotAllocationsEditor from '@/components/common/LotAllocationsEditor'
import { autoAllocations, autoCoveredSerials } from '@/components/common/conversionLots'

export default {
	name: 'ConversionLotsCell',
	components: { LotAllocationsEditor },
	props: {
		item: { type: Object, required: true },
		quantityKey: { type: String, required: true },
		// documento di acquisto in creazione: le matricole e i lotti creati al volo
		// prendono il suo fornitore (company_id), come nel form del DDT di acquisto
		documentParent: { type: Object, default: null }
	},
	data() {
		return { open: false }
	},
	computed: {
		quantity() {
			return parseFloat(this.item[this.quantityKey]) || 0
		},
		automatic() {
			// riga senza scelta che il backend copia da sola dal documento d'origine:
			// la cella mostra subito quei lotti e la finestra li propone gia' compilati
			return autoAllocations(this.item, this.quantityKey)
		},
		allocations() {
			return this.automatic || this.item.selected_lot_allocations || []
		},
		chosen() {
			return this.allocations.reduce((sum, a) => sum + (parseFloat(a.quantity) || 0), 0)
		},
		covered() {
			return this.quantity > 0 && Math.abs(this.chosen - this.quantity) < 0.0001
		},
		chipColor() {
			if (this.covered) return 'success'
			if (this.quantity <= 0) return 'grey'
			// scelta fatta ma che non copre la quantita': il backend la rifiuta
			if (this.item.lot_selection_touched && (this.item.selected_lot_allocations || []).length) return 'error'
			if (!this.item.serials) return 'grey'
			// matricole che il backend copia da solo: colore neutro
			return autoCoveredSerials(this.item, this.quantityKey) ? 'grey' : 'error'
		},
		label() {
			return (this.item.serials ? 'Matricole ' : 'Lotti ') + Math.round(this.chosen * 10000) / 10000 + '/' + this.quantity
		},
		field() {
			return {
				key: 'selected_lot_allocations',
				options: this.item.lot_options || [],
				row_direction: this.item.row_direction,
				allow_create: !!this.item.lot_allow_create,
				document_parent: this.documentParent
			}
		},
		model() {
			// modello locale per l'editor: la quantita' da coprire e' quella da convertire
			return {
				product_id: this.item.product_id,
				lots: this.item.lots,
				serials: this.item.serials,
				unit_factor: this.item.unit_factor,
				quantity: this.quantity,
				selected_lot_allocations: this.allocations
			}
		}
	},
	methods: {
		onChanged(allocations) {
			Vue.set(this.item, 'selected_lot_allocations', allocations.map((a) => ({ lot_id: a.lot_id, lot_id_text: a.lot_id_text, quantity: parseFloat(a.quantity) || 0 })))
			Vue.set(this.item, 'lot_selection_touched', true)
		}
	}
}
</script>
